'use client';

import { Button, type ButtonProps } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/utils';

type EButtonProps = ButtonProps;

function buildButtonClassName(baseClassName: string, className?: string) {
    return cn(
        'border-transparent text-[14px] font-medium text-white transition-colors',
        baseClassName,
        className,
    );
}

export function EPrimaryBtn({ className, ...props }: EButtonProps) {
    return <Button variant="secondary" className={buildButtonClassName('bg-[#2D8CEB] text-[#FFFFFF] text-[14px] hover:bg-[rgba(45,140,235,0.9)]', className)} {...props} />;
}

export function ESecondaryBtn({ className, ...props }: EButtonProps) {
    return <Button variant="secondary" className={buildButtonClassName('bg-[#383838] text-[#EBEBEB] text-[14px] hover:bg-[#424242]', className)} {...props} />;
}